// @flow
export const DIALOG_TYPE = 'DIALOG_TYPE_NPS_SURVEY';
